import Cookies from 'js-cookie'
import common from '@/utils/common'
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    theme: 'default',
    livenewsChannels: Cookies.get('livenewsChannels') || '[]',
    visitedViews: [],
    shade: false,
    // tag
    groupIndex: 0, // tag分组的index
    groupArray: [],
    groupCache: [], // [[]]二维数组，保存需要缓存的页面标识
    appScrollbarObject: {} // key为 groupIndex+componentName（组件名称）记录页面滚动距离
  },
  mutations: {
    SET_APP_SCROLLBAR: (state, { key, value }) => {
      state.appScrollbarObject[key] = value
    },
    SET_GROUP_INDEX: (state, index) => {
      state.groupIndex = index
    },
    ADD_GROUP: (state, defaultView) => {
      // 刷新进入
      if (defaultView) {
        state.groupArray.push([defaultView])
      } else {
        state.groupArray.push([])
      }
    },
    DEL_GROUP: (state, index) => {
      state.groupArray.splice(index, 1)
    },
    ADD_ROUTER_ITEM: (state, view) => {
      state.groupArray[state.groupIndex].push(view)
    },
    DEL_ROUTER_ITEM: (state, { index, len }) => {
      state.groupArray[state.groupIndex].splice(index, len || 1)
    },
    SET_GROUP_CACHE: (state, { key, info }) => {
      state.groupCache[key] = info
    },
    DEL_GROUP_CACHE: (state, index) => {
      Object.keys(state.groupCache).forEach(key => {
        // 找到所有的当前的key
        if (key.indexOf(`${index}/`) === 0) {
          // 删除信息
          delete state.groupCache[key]
        }
      })
    },
    // 移除缓存项
    DEL_CACHE_ITEM: (state, key) => {
      delete state.groupCache[key]
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CHANGE_VISITED_VIEWS: (state, view) => {
      view[1] = common.localGetKey('setTagIndex')
      if (view[0].components && view[0].components.default && view[0].components.default.name) {
        view[0].compName = view[0].components.default.name
      }
      state.visitedViews.splice(view[1], 1, { name: view[0].name, path: view[0].path, compName: view[0].compName, meta: view[0].meta })
    },
    ADD_VISITED_VIEWS: (state, view) => {
      let _routerState = false
      const argumentsCount = (str = view.path, symbol = ':') => {
        let count = 0
        for (let index = 0; index < str.length; index++) {
          if (str[index] == symbol) {
            count = count + 1
          }
        }
        return count
      }
      const _pathCount = argumentsCount()
      const _viewPath = view.path.split('/').slice(1, view.path.split('/').length - _pathCount)
      const isDetailPath = item => {
        if (view.path.indexOf(':') < 0) return false
        // 判断与本页参数数量是否一样
        if (_pathCount != Object.keys(item.params).length) return false
        // 截取路径
        const _itemPath = item.path
          .split('/')
          .slice(1, item.path.split('/').length - _pathCount)
        if (_viewPath.toString() === _itemPath.toString()) {
          return true
        } else {
          return false
        }
      }
      const getCompName = () => {
        if (view.components && view.components.default && view.components.default.name) {
          return view.components.default.name
        }
      }

      state.visitedViews.forEach((item, index, array) => {
        if (item.path == view.path) {
          _routerState = true
          return false
        } else if (isDetailPath(item)) {
          array.splice(index, 1, { name: view.name, path: view.path, compName: getCompName(), meta: view.meta })
          _routerState = true
          return false
        }
      })
      if (_routerState) return
      state.visitedViews.push({ name: view.name, path: view.path, compName: getCompName(), meta: view.meta })
    },
    DEL_VISITED_VIEWS: (state, view) => {
      let index
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          index = i
          break
        }
      }
      state.visitedViews.splice(index, 1)
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    CLOSE_SHADE: (state, shade) => {
      state.shade = shade
    }
  },
  actions: {
    /**
     * 更改当前选中的tagIndex
     * @param {*} index
     */
    setGroupIndex: ({ commit }, index) => {
      commit('SET_GROUP_INDEX', index)
    },
    /**
     * 新增分组
     * @param {*} defaultView
     */
    addGroup: ({ commit }, defaultView) => {
      commit('ADD_GROUP', defaultView)
    },
    /**
     * 删除分组
     * @param {*} index
     * @treunt { Boolean } 移动:t/f
     */
    delGroup: ({ dispatch, commit, state }, index) => {
      return new Promise(resolve => {
        // 保留最后tag
        if (state.groupArray.length - 1 > 0) {
          commit('DEL_GROUP', index)
          commit('DEL_GROUP_CACHE', index)
          // 关闭当前选中左侧，更新index
          if (index <= state.groupIndex) {
            dispatch('setGroupIndex', state.groupIndex - 1 > 0 ? state.groupIndex - 1 : 0)
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          resolve(false)
        }
      })
    },
    /**
     * 追加子项路由信息
     * @param {*} view
     */
    addRouterItem: ({ dispatch, commit, state }, view) => {
      const groupArray = state.groupArray[state.groupIndex] || []
      // 判断长度是否可以直接添加
      if (groupArray.length < 20) {
        commit('ADD_ROUTER_ITEM', view)
      } else if (groupArray.length >= 20) {
        // 移除第一位然后追加
        dispatch('delRouterItem', 0)
        commit('ADD_ROUTER_ITEM', view)
      }
      state.groupArray[state.groupIndex].splice(state.groupIndex, groupArray)
    },
    /**
     * 移除路由子项
     * @param {*} index
     */
    delRouterItem: ({ commit }, index) => {
      commit('DEL_ROUTER_ITEM', { index, len: 1 })
    },
    /**
     * 移除多个路由子项
     * @param {*} param0
     * @param {*} { index, len }
     */
    delMultiRouterItem: ({ commit }, { index, len }) => {
      commit('DEL_ROUTER_ITEM', { index, len })
    },
    /**
     * 保存缓存信息
     * @param {keys,cache} cache
     */
    setGroupCache: ({ commit }, cache) => {
      commit('SET_GROUP_CACHE', cache)
    },
    /**
     * 移除缓存子项
     * @param {*} key
     */
    delCacheItem: ({ commit }, key) => {
      commit('DEL_CACHE_ITEM', key)
    },
    /**
     * @function resetPath 更改跳转地址
     * @description 根据保存的历史记录,更改返回操作跳转的地址,同时更改缓存信息
     * @param {*} { to, form }
     * @return { Object } {type:(next,go) }
     */
    resetPath: ({ dispatch, commit, state }, { to, from }) => {
      return new Promise(resolve => {
        // 当前路由历史
        const currentHistry = state.groupArray[state.groupIndex]
        // 刷新页面，无form，无currentHistry groupIndex=0
        if (currentHistry === undefined || state.groupArray.length === 0) {
          commit('ADD_GROUP', to)
          resolve()
          return // 停止不执行下面代码
        }

        /** 切换tab不追加 */
        if (from.params.changeTab === true) {
          resolve()
          return
        }

        /**
         * 切换页面中的tab组件会更改query，导致会记录多个同一个页面的信息
         * 只要链接相同，且query存在active的不记录路由
          */
        if ((to.query.active || from.query.active) && to.path === from.path) {
          resolve()
          return
        }

        // 此处只增加信息
        dispatch('addRouterItem', to)
        resolve()
      })
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    addVisitedViews: ({ commit }, view) => {
      commit('ADD_VISITED_VIEWS', view)
    },
    changeVisitedViews: ({ commit }, view) => {
      commit('CHANGE_VISITED_VIEWS', view)
    },
    delVisitedViews: ({ commit, state }, view) =>
      new Promise(resolve => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      }),
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    closeShade({ commit }, { shade }) {
      commit('CLOSE_SHADE', shade)
    }

  }
}

export default app
